import { Injectable, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { PermissionType, ResourceNames } from '@enums/acl/resources.enum';
import { RoutesEnum } from '@enums/routes.enum';
import { AclAbilityService } from '@services/acl/acl.ability';
import { ExtraValidationsService } from '@services/acl/extra-validations.service';

@Injectable()
export class RoleGuard implements CanActivate {
  constructor(
    private router: Router,
    private aclService: AclAbilityService,
    private extraValidatorService: ExtraValidationsService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const resourceName = route.data['resource'];
    let allowed = true;
    if (resourceName) {
      const aclResult = this.aclService.canListAll(resourceName);
      const extraValidations = await this.extraValidatorService.getAllValidators();
      const validatorForResource = extraValidations.find(
        (validator) => validator.resource === resourceName && validator.permission === PermissionType.LIST_ALL
      );

      if (!validatorForResource) {
        allowed = aclResult;
      } else {
        allowed = aclResult && validatorForResource.isValid;
      }
      if (!allowed) {
        if (resourceName === ResourceNames.DASHBOARD && this.aclService.canListAll(ResourceNames.ATTENDANCE)) {
          this.router.navigate([`/panel/${RoutesEnum.CHAT}`]);
        } else if (resourceName === ResourceNames.ATTENDANCE && this.aclService.canListAll(ResourceNames.DASHBOARD)) {
          this.router.navigate([`/panel/${RoutesEnum.DASHBOARD}`]);
        } else {
          this.router.navigate(['/']);
        }
      }
    }
    return allowed;
  }
}
